<template>
  <svg stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
</template>
